import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header';
import { FaSearch } from "react-icons/fa";
import MaterialTable from '../../Components/Table/MaterialTable';
import { tableEye } from '../../common/Assets/imgs';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../Services/Constant';
import { get, post} from '../../Services/ApiHandler';
import toast from 'react-hot-toast';
// import Loader from '../../Components/Loader';

const Users = () => {

    const navigation = useNavigate();
    const [adminList,setAdminList]=useState([]);
    const [search,setSearch]=useState("");
     const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(1);
    
    const pageSize = 10;
    const columns = [
      {
        header: "S.No",
        // accessorFn: (row, index) => index + 1,
             accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
        id: "serial_no",
              }, 
         {
            accessorKey: "user_code",
            header: "User ID",
        },
        {
            accessorKey: "name",
            header: "User Name",
             Cell: ({ row }) => {
        const text = row.original.name || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
        },
        {
            accessorKey: "mobile",
            header: "Mobile Number",
        },
        {
            accessorKey: "created_at",
            header: "Registration Date",
             Cell: ({ cell }) => {
    const value = cell.getValue();
    if (!value) return "-";

    const date = new Date(value);

    const formattedDate = date.toLocaleDateString("en-GB"); 
    // en-GB gives DD/MM/YYYY

    return <span>{formattedDate.replace(/\//g, "-")}</span>;
  },
        },
        {
            accessorKey: "status",
            header: "Status",
           Cell: ({ cell, row }) => {
          return (
            // <button
            //   className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
           <span className={` ${cell.getValue() ? "status-active" : "status-inactive"} `}
              onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
            >
              {cell.getValue() ? "Active" : "Deactive"}
           </span>
            // </button>
          );
        },
        },
        {
            id: "action", // ✅ important when no accessorKey
            header: "Action",
            Cell: ({ row }) => (
                <div onClick={() => navigation('/view-users',
                    {
                        state:
                        {data:row.original,
                            type:"view"
                        }
                    }
                )}>
                    <img src={tableEye} alt="" className='tableeye' />
                </div>
            ),
        },
    ];

    const getList = async(src,page) =>{
        try {
             setLoader(true);
            const response = await get(`${URLS.USER_MANAGEMENT_LIST}?search=${src}&page=${page}`);
            console.log('response',response);
            setAdminList(response?.data);
             setLoader(false);
        }
        catch(err){
            console.log('err',err);
             setLoader(false);
        }
    }

    useEffect(()=>{
getList(search,pagination);
    },[search,pagination])

//  const statusChanger = (id,currentStatus)=>{
//     put(`${URLS.USER_MANAGEMENT_STATUS}${id}/`,{
//       status:currentStatus === true ? false : true,
//     })
//  }

// const statusChanger = (id, currentStatus) => {
//   const newStatus = !currentStatus;

//   put(`${URLS.USER_MANAGEMENT_STATUS}${id}/${newStatus}/`);
// };

const statusChanger = (id,status) =>{
    const payload = new FormData();
    payload.append("user_id",id)
    payload.append("status",!status)
    post(URLS.USER_MANAGEMENT_STATUS,payload) 
    .then((res)=>{
        if(res?.status === "success"){
            getList(search,pagination);
            toast.success(res?.message);
        }
    })
    .catch((err)=>{
        console.log("err",err)
    })
}

    return (
        <div>
            <Header title={"User Management"}/>

            <div className="container-fluid main-container">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

                    {/* LEFT TITLE */}
                    <h3 className="m-0 fw-bold fs-5 text-black">Users</h3>


                  {/* SEARCH BOX */}
                                         <div className="search-box d-flex align-items-center px-3"
                                         >
                                             <input
                                                 type="text"
                                                 placeholder="Search"
                                                 className="border-0 outline-none bg-transparent"
                                                 value={search}
                                                 onChange={(e) => setSearch(e.target.value)}
                                             />
                                             <div className="ms-2 searchdote" >|</div>
                                             <FaSearch color='#7A52AB' className="ms-1" />
                                         </div>


                </div>
                <MaterialTable columns={columns}
                 data={adminList || []} 
                pagination={pagination}
                 setPagination={setPagination}
                 loading={loader} />
            </div>
        </div>
    );
};

export default Users;
